import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './admin.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: LOCALE_ID, useValue: 'pt-PT' },
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes)
    ]
};
